// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logoSettingsContainer_jSOKz {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.logoUploadBox_E3dmj {
  border: 2px dotted #e5e7eb;
  border-radius: 8px;
  padding: 32px 0;
  text-align: center;
}

.uploadIconWrapper_thMDN {
  margin-bottom: 8px;
}

.uploadButton_xvViq {
  background-color: #000000;
  color: var(--white-background);
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 10px;
  margin-bottom: 12px;
}

.uploadText_VXVnu {
  font-weight: bold;
  font-size: 20px;
  color: #374151;
}

.uploadDescription_MujKU {
  font-size: 14px;
  color: var(--9ca3af-color);
}

.logoOptionsContainer_KheWo {
  display: flex;
  flex-direction: column;
  gap: 20px;
  transition: all 0.3s ease-in-out;
  transform-origin: top;
}

.logoOptionsContainer_KheWo.hidden_ItBMO {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transform: scaleY(0);
  margin-top: 0;
  margin-bottom: 0;
}

.logoOptionsContainer_KheWo.visible_Ph1fN {
  opacity: 1;
  max-height: none;
  transform: scaleY(1);
}

.logoPreviewContainer_L23sL {
  position: relative;
  width: fit-content;
  margin-left:auto;
}

.logoPreview_YAOPO {
  max-width: 100px;
  max-height: 100px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.removeLogoButton_kp1_s {
  position: absolute;
  top: -5px;
  right: -5px;
  z-index: 10;
  background-color: #000000 !important;
}

.checkboxContainer_UsRey {
  display: flex;
  align-items: center;
  gap: 8px;
}



@media (max-width: 1024px) {
  .logoSettingsContainer_jSOKz {
    gap: 18px;
    min-height: auto;
  }

  .logoUploadBox_E3dmj {
    padding: 28px 16px;
  }

  .uploadButton_xvViq {
    font-size: 11px;
    padding: 6px 10px;
    margin-bottom: 10px;
  }

  .uploadText_VXVnu {
    font-size: 18px;
  }

  .uploadDescription_MujKU {
    font-size: 13px;
    line-height: 1.4;
  }

  .logoOptionsContainer_KheWo {
    gap: 18px;
  }

  .logoOptionsContainer_KheWo.visible_Ph1fN {
    max-height: none;
  }

  .logoPreview_YAOPO {
    max-width: 85px;
    max-height: 85px;
  }

  .checkboxContainer_UsRey {
    gap: 7px;
  }

}

@media (max-width: 768px) {
  .logoSettingsContainer_jSOKz {
    gap: 16px;
    min-height: auto; 
  }

  .logoUploadBox_E3dmj {
    padding: 20px 12px; 
  }

  .uploadButton_xvViq {
    font-size: 11px;
    padding: 5px 10px;
    margin-bottom: 8px; 
  }

  .uploadText_VXVnu {
    font-size: 16px; 
  }

  .uploadDescription_MujKU {
    font-size: 12px; 
    line-height: 1.3;
  }

  .logoOptionsContainer_KheWo {
    gap: 14px; 
  }

  .logoOptionsContainer_KheWo.visible_Ph1fN {
    max-height: none; 
  }

  .logoPreview_YAOPO {
    max-width: 70px; 
    max-height: 70px;
  }

  .checkboxContainer_UsRey {
    gap: 6px;
  }


}

@media (max-width: 480px) {
  .logoSettingsContainer_jSOKz {
    gap: 12px;
  }

  .logoUploadBox_E3dmj {
    padding: 16px 8px; 
  }

  .uploadText_VXVnu {
    font-size: 14px; 
  }

  .uploadDescription_MujKU {
    font-size: 11px;
    line-height: 1.2;
  }

  .logoOptionsContainer_KheWo.visible_Ph1fN {
    max-height: none; 
  }

  .logoPreview_YAOPO {
    max-width: 60px;
    max-height: 60px;
  }


}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/SettingsPanel/LogoSettings.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;;;AAIA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;AAEF;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;;AAGF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;;AAGF","sourcesContent":[".logoSettingsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.logoUploadBox {\n  border: 2px dotted #e5e7eb;\n  border-radius: 8px;\n  padding: 32px 0;\n  text-align: center;\n}\n\n.uploadIconWrapper {\n  margin-bottom: 8px;\n}\n\n.uploadButton {\n  background-color: #000000;\n  color: var(--white-background);\n  font-size: 12px;\n  padding: 6px 12px;\n  border-radius: 10px;\n  margin-bottom: 12px;\n}\n\n.uploadText {\n  font-weight: bold;\n  font-size: 20px;\n  color: #374151;\n}\n\n.uploadDescription {\n  font-size: 14px;\n  color: var(--9ca3af-color);\n}\n\n.logoOptionsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  transition: all 0.3s ease-in-out;\n  transform-origin: top;\n}\n\n.logoOptionsContainer.hidden {\n  opacity: 0;\n  max-height: 0;\n  overflow: hidden;\n  transform: scaleY(0);\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.logoOptionsContainer.visible {\n  opacity: 1;\n  max-height: none;\n  transform: scaleY(1);\n}\n\n.logoPreviewContainer {\n  position: relative;\n  width: fit-content;\n  margin-left:auto;\n}\n\n.logoPreview {\n  max-width: 100px;\n  max-height: 100px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.removeLogoButton {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  z-index: 10;\n  background-color: #000000 !important;\n}\n\n.checkboxContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n\n\n@media (max-width: 1024px) {\n  .logoSettingsContainer {\n    gap: 18px;\n    min-height: auto;\n  }\n\n  .logoUploadBox {\n    padding: 28px 16px;\n  }\n\n  .uploadButton {\n    font-size: 11px;\n    padding: 6px 10px;\n    margin-bottom: 10px;\n  }\n\n  .uploadText {\n    font-size: 18px;\n  }\n\n  .uploadDescription {\n    font-size: 13px;\n    line-height: 1.4;\n  }\n\n  .logoOptionsContainer {\n    gap: 18px;\n  }\n\n  .logoOptionsContainer.visible {\n    max-height: none;\n  }\n\n  .logoPreview {\n    max-width: 85px;\n    max-height: 85px;\n  }\n\n  .checkboxContainer {\n    gap: 7px;\n  }\n\n}\n\n@media (max-width: 768px) {\n  .logoSettingsContainer {\n    gap: 16px;\n    min-height: auto; \n  }\n\n  .logoUploadBox {\n    padding: 20px 12px; \n  }\n\n  .uploadButton {\n    font-size: 11px;\n    padding: 5px 10px;\n    margin-bottom: 8px; \n  }\n\n  .uploadText {\n    font-size: 16px; \n  }\n\n  .uploadDescription {\n    font-size: 12px; \n    line-height: 1.3;\n  }\n\n  .logoOptionsContainer {\n    gap: 14px; \n  }\n\n  .logoOptionsContainer.visible {\n    max-height: none; \n  }\n\n  .logoPreview {\n    max-width: 70px; \n    max-height: 70px;\n  }\n\n  .checkboxContainer {\n    gap: 6px;\n  }\n\n\n}\n\n@media (max-width: 480px) {\n  .logoSettingsContainer {\n    gap: 12px;\n  }\n\n  .logoUploadBox {\n    padding: 16px 8px; \n  }\n\n  .uploadText {\n    font-size: 14px; \n  }\n\n  .uploadDescription {\n    font-size: 11px;\n    line-height: 1.2;\n  }\n\n  .logoOptionsContainer.visible {\n    max-height: none; \n  }\n\n  .logoPreview {\n    max-width: 60px;\n    max-height: 60px;\n  }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoSettingsContainer": `logoSettingsContainer_jSOKz`,
	"logoUploadBox": `logoUploadBox_E3dmj`,
	"uploadIconWrapper": `uploadIconWrapper_thMDN`,
	"uploadButton": `uploadButton_xvViq`,
	"uploadText": `uploadText_VXVnu`,
	"uploadDescription": `uploadDescription_MujKU`,
	"logoOptionsContainer": `logoOptionsContainer_KheWo`,
	"hidden": `hidden_ItBMO`,
	"visible": `visible_Ph1fN`,
	"logoPreviewContainer": `logoPreviewContainer_L23sL`,
	"logoPreview": `logoPreview_YAOPO`,
	"removeLogoButton": `removeLogoButton_kp1_s`,
	"checkboxContainer": `checkboxContainer_UsRey`
};
export default ___CSS_LOADER_EXPORT___;
